module.exports = __webpack_public_path__ + "static/media/thumbnail-IMG_1053.ca8d322a.jpg";